// Backoff for followWithRetry: doubles per failure in a row, capped at the max.
export const SUBSCRIPTION_RETRY_INITIAL_DELAY_MS = 5_000;
export const SUBSCRIPTION_RETRY_MAX_DELAY_MS = 30_000;

export const SUBSCRIPTION_LOST_TOAST_KEY = 'subscription-connection-lost';

// The machine's status catches up a moment after the device reports a change, so it is read again after this wait.
export const ROBOT_STATUS_REFRESH_DELAY_MS = 2_000;
// The longest a steady stream of events can hold the refresh off.
export const ROBOT_STATUS_REFRESH_MAX_WAIT_MS = 10_000;

// Groups the burst of schedule events a robot sync publishes into one refetch.
export const SCHEDULE_REFRESH_DEBOUNCE_MS = 1_000;
